import { useQuery } from "@tanstack/react-query";
import { useStore } from "@tanstack/react-store";
import { AnimatePresence } from "motion/react";

import { initiativesQuery } from "../lib/queries";
import { routeStore } from "../lib/store";
import type { VoidComponent } from "../lib/types";
import { CategoryRoute } from "./category-route";
import { InitiativeRoute } from "./initiative-route";
import { PillarRoute } from "./pillar-route";

const Routes: VoidComponent = () => {
	const { level, params } = useStore(routeStore);
	const initiatives = useQuery(initiativesQuery);

	return (
		<AnimatePresence mode="wait">
			{level === "pillar" && <PillarRoute key={params.pillar} params={params} />}

			{level === "category" && initiatives.isSuccess && (
				<CategoryRoute key={params.category} params={params} data={initiatives.data} />
			)}

			{level === "initiative" && initiatives.isSuccess && (
				<InitiativeRoute key={params.initiative} params={params} data={initiatives.data} />
			)}
		</AnimatePresence>
	);
};

export { Routes };
